import {z} from 'zod';

import {parseJSON} from 'shared/web';

const CheckinDataSchema = z.object({
  scheduledDate: z.string().nullish(),
  completedDate: z.string().nullish(),
  mileage: z.string().nullish(),
  fuelAmount: z.string().nullish(),
});

export const getCheckinData = (dataJson: string) => {
  const data = parseJSON(dataJson, CheckinDataSchema);

  return data;
};
